import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

// services
import { TranslateService } from '@ngx-translate/core';
import { FocusStackService } from '@app/shared/services/focus-stack.service';

// types
import {
  ProfileCollectionViewModel,
  ProfileCollectionFacade,
} from '@app/profile/components/profile-collection/profile-collection-reactive-store';

@Component({
  selector: 'dgx-profile-collection-bulk-update',
  templateUrl: './profile-collection-bulk-update.component.html',
  styleUrls: ['./profile-collection-bulk-update.component.scss'],
})
export class ProfileCollectionBulkUpdate implements OnInit {
  public vm$: Observable<ProfileCollectionViewModel>;

  public i18n = this.translateService.instant([
    'Core_YesSure',
    'UserController_EditCategories',
    'UserController_Delete',
    'ProfileCtrl_DeleteCollectionGenericItemBody',
  ]);

  constructor(
    private translateService: TranslateService,
    private focusStackService: FocusStackService,
    private profileCollectionFacade: ProfileCollectionFacade
  ) {}

  public ngOnInit(): void {
    this.vm$ = this.profileCollectionFacade.vm$;
  }

  public resetBulkEdit(): void {
    this.profileCollectionFacade.resetBulkUpdate();
  }

  public bulkDelete(): void {
    this.profileCollectionFacade.showBulkDeleteModal();
  }

  public bulkUpdate(): void {
    this.focusStackService.push();
    this.profileCollectionFacade.showBulkUpdateModal();
  }
}
